<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <vc-layout :spacing="spacing">
      <vc-col :span="12" sm24>
        <example-title src="example-1.html" title="Default" :class="['tabs-example']" />
        <vc-tabstrip name="tabstrip-0" @tab="onTab($event)">
          <vc-tabstrip-pane label="Home">
            <h4 :class="demoTabHeader">Home</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="About">
            <h4 :class="demoTabHeader">About</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="Projects">
            <h4 :class="demoTabHeader">Projects</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
        </vc-tabstrip>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-2.html" title="Preselected, custom color and disabled item" :class="['tabs-example']" />
        <vc-tabstrip name="tabstrip-1" :tab-selected="2" color="deep-purple" slider-color="orange" @tab="onTab($event)">
          <vc-tabstrip-pane label="Home">
            <h4 :class="demoTabHeader">Home</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="About" :disabled="true">
            <h4 :class="demoTabHeader">About</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="Projects">
            <h4 :class="demoTabHeader">Projects</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
        </vc-tabstrip>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="spacing">
      <vc-col :span="12" sm24>
        <example-title src="example-3.html" title="Tabs with icons, right aligned" :class="['tabs-example']" />
        <vc-tabstrip align="right" name="tabstrip-2" color="green" slider-color="yellow" @tab="onTab($event)">
          <vc-tabstrip-pane label="Home" icon="home">
            <h4 :class="demoTabHeader">Home</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="About" icon="supervisor_account">
            <h4 :class="demoTabHeader">About</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="Projects" icon="info">
            <h4 :class="demoTabHeader">Projects</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
        </vc-tabstrip>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-4.html" title="Tabs with icons large icons, left aligned" :class="['tabs-example']" />
        <vc-tabstrip align="left" name="tabstrip-5" color="green" slider-color="yellow" icon-size="normal" @tab="onTab($event)">
          <vc-tabstrip-pane label="Home" icon="home">
            <h4 :class="demoTabHeader">Home</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="About" icon="supervisor_account">
            <h4 :class="demoTabHeader">About</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="Projects" icon="info">
            <h4 :class="demoTabHeader">Projects</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
        </vc-tabstrip>
      </vc-col>
    </vc-layout>

    <vc-layout :spacing="spacing">
      <vc-col :span="12" sm24>
        <example-title src="example-5.html" title="Closable centered tabs, light theme" :class="['tabs-example']" />
        <vc-tabstrip align="center" name="tabstrip-3" closable :dark="false" color="orange l-300" slider-color="red" @tab="onTab($event)">
          <vc-tabstrip-pane label="Home">
            <h4 :class="demoTabHeader">Home</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="About">
            <h4 :class="demoTabHeader">About</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="Projects">
            <h4 :class="demoTabHeader">Projects</h4>
            <vc-lorem-ipsum />
          </vc-tabstrip-pane>
        </vc-tabstrip>
      </vc-col>
      <vc-col :span="12" sm24>
        <example-title src="example-6.html" title="Tabs with set height" :class="['tabs-example']" />
        <vc-tabstrip name="tabstrip-4" closable :tab-height="350" @tab="onTab($event)">
          <vc-tabstrip-pane label="Home">
            <h4 :class="demoTabHeader">Home</h4>
            <vc-lorem-ipsum :repeats="5" />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="Projects">
            <h4 :class="demoTabHeader">Projects</h4>
            <vc-lorem-ipsum :repeats="5" />
          </vc-tabstrip-pane>
          <vc-tabstrip-pane label="Mission">
            <h4 :class="demoTabHeader">Mission</h4>
            <vc-lorem-ipsum :repeats="5" />
          </vc-tabstrip-pane>
        </vc-tabstrip>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'TabstripPage',
  mixins: [
    methods
  ],
  data () {
    return {
      demoTabHeader: ['title', 'font-grey', 'font-l-600'],
      title: null,
      description: null,
      spacing: 12
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onTab (event) {
      console.log('vc-tab:tab', event)
    }
  }
}
</script>
<style>
.tabs-example .title
{
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/tabstrip.vue